module.exports = window.styled["6.6.0"];